/**
 * Image brightness/grayscale exclusion.
 *
 * Previously shipped inside free's Images.js::excludeFilterImages(), gated by
 * image_enabled_low_brightness/grayscale being forced empty for free installs.
 * WordPress.org guideline 5 does not permit shipping locked feature code in
 * the free plugin, so it lives here and free's Images.js no longer contains
 * this logic at all.
 *
 * Images.js is a factory that only exposes { init } (unlike Videos.js, which
 * is a class singleton with per-feature methods free's own code can
 * monkey-patch onto), so this is a standalone reimplementation rather than a
 * patch - following Accessibility.js/CustomTriggers.js's call-once,
 * DOMContentLoaded-only pattern, and re-attaching its own listener on the
 * same wp_dark_mode event free's Images.js fires on toggle (mirroring what
 * free's own initImages() used to do before this logic moved here).
 *
 * Copied verbatim from free's last working copy of excludeFilterImages() so
 * behaviour is identical to before.
 */
class ImageFilters {
	/**
	 * Init. Call exactly once, from DOMContentLoaded.
	 */
	init() {
		if (typeof wp_dark_mode_json === 'undefined') {
			return;
		}

		this.excludeFilterImages();

		document.addEventListener('wp_dark_mode', () => {
			this.excludeFilterImages();
		});
	}

	/**
	 * Applies the exclude lists to every image currently on the page.
	 */
	excludeFilterImages = () => {
		const lowBrightnessExcludes = wp_dark_mode_json.options.image_enabled_low_brightness ? wp_dark_mode_json.options.image_low_brightness_excludes : false;
		const lowGrayscaleExcludes = wp_dark_mode_json.options.image_enabled_low_grayscale ? wp_dark_mode_json.options.image_low_grayscale_excludes : false;

		const images = document.querySelectorAll('img, picture img, img[srcset], picture source, picture source[srcset]');

		if (images && images.length) {
			images.forEach((image) => {
				const src = image.src;

				if (lowBrightnessExcludes && lowBrightnessExcludes.includes(src)) {
					// Set filter to 0.
					image.style.setProperty('--wp-dark-img-brightness', '100%');
				}

				if (lowGrayscaleExcludes && lowGrayscaleExcludes.includes(src)) {
					// Set filter to 0.
					image.style.setProperty('--wp-dark-img-grayscale', '0%');
				}
			});
		}
	}
}

export default new ImageFilters();
